import React from 'react';
import { Row, Col, Typography, Form, Input, Button, Card, message } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const Contact = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    // 提交表单
    const handleSubmit = (values) => {
        console.log('表单提交: ', values);
        message.success(t('contact.form.successMessage'));
        form.resetFields();
    };

    return (
        <div className="container" style={{ padding: '50px 0' }}>
            {/* 页面标题 */}
            <div className="section-title">
                <Title level={2}>{t('contact.title')}</Title>
                <Paragraph>
                    {t('contact.subtitle')}
                </Paragraph>
            </div>

            <Row gutter={[48, 48]}>
                {/* 联系表单 */}
                <Col xs={24} lg={24}>
                    <Card
                        title={<Title level={3}>{t('contact.form.title')}</Title>}
                        style={{ height: '100%' }}
                    >
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSubmit}
                            requiredMark={false}
                        >
                            <Row gutter={16}>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        label={t('contact.form.name')}
                                        name="name"
                                        rules={[{ required: true, message: t('contact.form.nameRequired') }]}
                                    >
                                        <Input placeholder={t('contact.form.namePlaceholder')} size="large" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        label={t('contact.form.phone')}
                                        name="phone"
                                        rules={[{ required: true, message: t('contact.form.phoneRequired') }]}
                                    >
                                        <Input placeholder={t('contact.form.phonePlaceholder')} size="large" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item
                                label={t('contact.form.email')}
                                name="email"
                                rules={[
                                    { required: true, message: t('contact.form.emailRequired') },
                                    { type: 'email', message: t('contact.form.emailValid') },
                                ]}
                            >
                                <Input placeholder={t('contact.form.emailPlaceholder')} size="large" />
                            </Form.Item>

                            <Form.Item
                                label={t('contact.form.company')}
                                name="company"
                            >
                                <Input placeholder={t('contact.form.companyPlaceholder')} size="large" />
                            </Form.Item>

                            <Form.Item
                                label={t('contact.form.subject')}
                                name="subject"
                                rules={[{ required: true, message: t('contact.form.subjectRequired') }]}
                            >
                                <Input placeholder={t('contact.form.subjectPlaceholder')} size="large" />
                            </Form.Item>

                            <Form.Item
                                label={t('contact.form.message')}
                                name="message"
                                rules={[{ required: true, message: t('contact.form.messageRequired') }]}
                            >
                                <TextArea
                                    placeholder={t('contact.form.messagePlaceholder')}
                                    rows={6}
                                    size="large"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" size="large" style={{ minWidth: '120px' }}>
                                    {t('contact.form.submit')}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Contact;
